import { adminUsersByIdLinksPasswordResetPostSlice } from './post';

export const {
	requestPostAdminUsersByIdLinksPasswordResetSend,
	resetPostAdminUsersByIdLinksPasswordResetSend
} = adminUsersByIdLinksPasswordResetPostSlice.asyncActionCreators;
